import axios from "axios";
import API_BASE_URL from "../../config/api";

const BASE_URL = API_BASE_URL;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
  "Content-Type": "application/json",
});

const apiGet = async (url) => {
  const response = await axios.get(url, { headers: authHeaders() });
  return response.data;
};

const apiPost = async (url, body) => {
  const response = await axios.post(url, body, { headers: authHeaders() });
  return response.data;
};

const apiPut = async (url, body) => {
  const response = await axios.put(url, body, { headers: authHeaders() });
  return response.data;
};

const apiPatch = async (url, body) => {
  const response = await axios.patch(url, body, { headers: authHeaders() });
  return response.data;
};

const apiDelete = async (url) => {
  const response = await axios.delete(url, { headers: authHeaders() });
  return response.data;
};

export const listTemplates = () => apiGet(`${BASE_URL}/dane-templates`);
export const getTemplate = (id) => apiGet(`${BASE_URL}/dane-templates/${id}`);

export const createTemplate = (payload) =>
  apiPost(`${BASE_URL}/dane-templates`, payload);

export const updateTemplate = (id, payload) =>
  apiPut(`${BASE_URL}/dane-templates/${id}`, payload);

export const deleteTemplate = (id) =>
  apiDelete(`${BASE_URL}/dane-templates/${id}`);

export const patchTemplateVisibility = (id, isPublic) =>
  apiPatch(`${BASE_URL}/dane-templates/${id}/visibility`, {
    is_public: Boolean(isPublic),
  });

export const listTemplatePermissions = (id) =>
  apiGet(`${BASE_URL}/dane-templates/${id}/permissions`);

export const grantTemplatePermission = (id, userId, permission) =>
  apiPost(`${BASE_URL}/dane-templates/${id}/permissions`, {
    userId: Number(userId),
    permission,
  });

export const updateTemplatePermission = (id, userId, permission) =>
  apiPatch(`${BASE_URL}/dane-templates/${id}/permissions/${userId}`, {
    permission,
  });

export const revokeTemplatePermission = (id, userId) =>
  apiDelete(`${BASE_URL}/dane-templates/${id}/permissions/${userId}`);

export const getMyTemplatePermission = (id) =>
  apiGet(`${BASE_URL}/dane-templates/${id}/permissions/me`);

export const listTemplateUsers = () =>
  apiGet(`${BASE_URL}/dane-templates/users`);

export const copyTemplate = (id, description, isPublic = false) =>
  apiPost(`${BASE_URL}/dane-templates/${id}/copy`, {
    description,
    is_public: Boolean(isPublic),
  });
